import { defineStore } from 'pinia';
import loginActions from './actions';
import * as getters from './getters';

const loginStore = defineStore('login', {
  state: () => ({
    user: {},
    token: null,
    client: null,
    prestador: false,
    prestadorAdministrativo: false,
    beneficiario: false,
    dependente: false,
    operadora: false,
    ouvidoria: false,
    admin: false,
    permissions: null,
    uraBean: {},
  }),
  actions: loginActions,
  getters,
});

// eslint-disable-next-line import/prefer-default-export
export { loginStore };
